import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'smartNumber'
})
export class SmartNumberPipe implements PipeTransform {

  transform(value: number): string {
    if(!value) {
      return '';
    }
    // Convertir a número si es string
    const num = typeof value === 'string' ? parseFloat(value) : value;

    // Verificar si es un número válido
    if (isNaN(num)) {
      return value.toString();
    }

    // Si los decimales son .00, mostrar solo entero
    if (num % 1 === 0) {
      return num.toString();
    }

    // Si tiene decimales, mostrar con decimales (máximo 2)
    return num.toFixed(1);
  }

}
